import { TIMEOUT_DIALOG_MESSAGE } from  '../const/UI';

export function setDelay(ms = TIMEOUT_DIALOG_MESSAGE) {  
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  });
}